<div class="relative flex flex-col w-full">
  <div class="flex flex-row w-full align-middle items-center">
    <div class="flex flex-col w-full items-start">
      @if (type === 'textarea') {
        <textarea
          #inputElement
          [name]="name"
          [id]="id"
          [tabindex]="tabIndex"
          [readOnly]="readonly"
          class="peer placeholder-transparent block w-full h-20 max-h-40 bg-neutral-900 pt-1
            rounded-t text-sm/[16px] border-0 border-b-1 caret-cyan text-white/85 font-normal
            focus:border-b-cyan-highlight focus:outline-none focus:ring-0 disabled:opacity-50
            autofill:bg-neutral-900 autofill:text-white autofill:[-webkit-text-fill-color:white] autofill:shadow-[inset_0_0_0px_1000px_rgb(38,38,38)]"
          [ngClass]="{
            'border-b-error focus:border-b-error': formControl.touched && formControl.invalid,
            'border-b-gray-700': formControl.valid,
            'pr-10': true,
            'pl-10': icon,
            'pl-4': !icon,
            'pt-4': !!label,
            classList
          }"
          [placeholder]="placeholder"
          [formControl]="formControl | formControl"
          (input)="handleInputChange($event)"
        ></textarea>
      } @else {
        <input
          #inputElement
          [type]="type"
          [name]="name"
          [id]="id"
          [tabindex]="tabIndex"
          [autocomplete]="name"
          [readOnly]="readonly"
          class="peer placeholder-transparent block w-full h-11 bg-neutral-900 pt-1
            rounded-t text-sm/[16px] border-0 border-b-1 caret-cyan text-white
            focus:border-b-cyan-highlight focus:outline-none focus:ring-0 disabled:opacity-50
            autofill:bg-neutral-900 autofill:text-white autofill:[-webkit-text-fill-color:white] autofill:shadow-[inset_0_0_0px_1000px_rgb(38,38,38)]"
          [ngClass]="{
            'border-b-error focus:border-b-error': formControl.touched && formControl.invalid,
            'border-b-gray-700': formControl.valid,
            'pr-10': type !== 'number',
            'pl-10': icon,
            'pl-4': !icon,
            'pt-4': !!label,
            classList
          }"
          [placeholder]="placeholder"
          [formControl]="formControl | formControl"
          (input)="handleInputChange($event)"
        />
      }

      @if (label) {
        <label
          [for]="id"
          class="absolute mt-0.5 text-xxs text-white/60 peer-focus:text-cyan
            peer-placeholder-shown:text-white/60
            peer-placeholder-shown:mt-3
            peer-placeholder-shown:text-sm/[16px]
            duration-300"
          [ngClass]="{
            'text-error peer-focus:text-error': formControl.touched && formControl.invalid,
            'ml-10 peer-placeholder-shown:mt-4': icon,
            'ml-4': !icon
          }"
        >{{ label }}</label>
      }
    </div>

    @if (icon) {
      <div class="absolute h-6 w-6 ps-1.5 left-2">
        <nrc-icon [name]="icon" class="w-4 h-4"/>
      </div>
    }

    <div class="absolute h-3.5 ps-2 right-4">
      @if (!formControl.disabled && clearEnabled) {
        <button class="flex h-full" type="button" tabindex="-1" (click)="resetInput()">
          <nrc-icon [name]="'clear'" class="w-3 h-3"/>
        </button>
      }

      @if (clipboardEnabled) {
        <nrc-icon
          class="w-4 h-4 cursor-pointer hover:scale-90 transition-transform duration-250"
          [name]="'clipboard'"
          (click)="copyToClipboard(formControl.value)"
        />
      }
    </div>
  </div>

  @if (hint) {
    <p class="text-xs text-white/50 py-1">
      {{ hint }}
    </p>
  }

  @if (invalidHint && formControl.invalid && formControl.touched) {
    <p class="text-xs text-error leading-tight tracking-[.01125em] pt-1">
      {{ invalidHint }}
    </p>
  }
</div>
